exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#logo-home{width:auto;max-width:170px;height:auto}.card--flex-toolbar{margin-top:-64px}.items{overflow:auto;max-height:calc(100vh - 112px)}.expandableContainer{border-style:solid!important;border-color:#e6e6e6!important;border-radius:15px!important;border-width:2px!important}.spacerst{margin-right:-140px}", ""]);

// exports
